class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input   = this.querySelector('.ajax-search__input');
    this.panel   = this.querySelector('.ajax-search__panel');
    this.results = this.querySelector('[data-results]');
    this.loader  = this.querySelector('[data-loader]');
    this.reset   = this.querySelector('.ajax-search__reset');
    this.form    = this.querySelector('form');

    this.cache = {};
    this.controller = null;
    this.debounceTimer = null;
    this.minChars = 2;
  }

  connectedCallback() {
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('keydown', this.onKeydown.bind(this));
    this.reset.addEventListener('click', this.clear.bind(this));
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
  }

  onInput() {
    const term = this.input.value.trim();
    clearTimeout(this.debounceTimer);
    if (term.length < this.minChars) { this.close(); return; }
    this.debounceTimer = setTimeout(() => this.search(term), 250);
  }

  onFocus() {
    const term = this.input.value.trim();
    if (term.length >= this.minChars) this.search(term);
  }

  search(term) {
    if (this.cache[term]) { this.render(this.cache[term]); return; }

    this.setLoading(true);
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const url =
      `${root}search/suggest` +
      `?q=${encodeURIComponent(term)}` +
      `&section_id=predictive-search` +
      `&resources[type]=query,product,collection` +
      `&resources[limit]=8` +
      `&resources[limit_scope]=each` +
      `&resources[options][unavailable_products]=last`;

    fetch(url, { signal: this.controller.signal })
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const node = doc.querySelector('#shopify-section-predictive-search [data-search-results]');
        const markup = node ? node.outerHTML : '';
        this.cache[term] = markup;
        this.render(markup);
      })
      .catch((err) => { if (err.name !== 'AbortError') console.error(err); })
      .finally(() => this.setLoading(false));
  }

  render(markup) {
    this.results.innerHTML = markup;
    this.open();
  }

  setLoading(state) {
    this.loader.hidden = !state;
    this.input.setAttribute('aria-busy', state);
  }

  open() {
    this.panel.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
  }

  clear() {
    this.input.value = '';
    this.results.innerHTML = '';
    this.close();
    this.input.focus();
  }

  // Basic keyboard navigation through result links
  onKeydown(e) {
    if (this.panel.hidden) return;
    const links = Array.from(this.panel.querySelectorAll('[data-search-link]'));
    if (!links.length) return;
    const current = links.indexOf(document.activeElement);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      (links[current + 1] || links[0]).focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      (links[current - 1] || links[links.length - 1]).focus();
    } else if (e.key === 'Escape') {
      this.close();
      this.input.focus();
    }
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}